import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { StoreService } from 'src/app/shared/services/store.service';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';

declare let google : any;

@Component({
    selector: 'app-chi-siamo',
    templateUrl: './page-chi-siamo.component.html',
    styleUrls: ['./page-chi-siamo.component.scss']
})
export class PageChiSiamoComponent implements OnInit {
    shopInfo;
    legalInfo;
    orariInfo;
    logo;
    map_link;

    daysOrder = [1, 2, 3, 4, 5, 6, 0];
    dayName = {
      '1': 'Lun',
      '2': 'Mar',
      '3': 'Mer',
      '4': 'Gio',
      '5': 'Ven',
      '6': 'Sab',
      '0': 'Dom'
    };

    formatTime (time) {
        return String(Math.floor(time / 60)).padStart(2, '0') + ':' + String(time % 60).padStart(2, '0');
    }
    
    constructor(public store: StoreService,
        private sanitizer: DomSanitizer) { }

    ngOnInit() {
        this.shopInfo = this.store.aziendaInfo;
        if (this.store.logo) {
            fetch(this.store.logo).then(response => {
                this.logo = this.store.logo;
            })
        }

        let pos = this.store.lat_lng;

        const google_map = new google.maps.Map(document.getElementById("store_map"), {
            zoom: 18,
            center: pos,
            clickableIcons: false
        });

        const marker = new google.maps.Marker({
            position: pos,
            map: google_map
        });

        this.store.getAziendaLegalInfo().subscribe(legalInfo => {
            this.legalInfo = legalInfo;
        });

        this.store.getOrariDelNegozio().pipe(map(orari => {
            let group = {};
            for (let i = 0; i <= 6; i++)
                group[i] = [];

            for (let orario of orari) {
                group[orario.giorno_della_settimana].push([orario.orario_inizio, orario.orario_fine]);
            }

            return group;
        })).subscribe(orariInfo => {
            this.orariInfo = orariInfo;
        })
    }

    get indirizzo() {
        if (this.shopInfo)
            return `${this.shopInfo.indirizzo} - ${this.shopInfo.cap} ${this.shopInfo.citta} (${this.shopInfo.provincia})`;
    }

}
